import type { JSX, Ref } from 'react'
import type { IconNames, IconQualitySizes, IconSizes } from 'atoms/Icon'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { COLOR } from 'vars/index'
import type { Backgrounds, BorderColors, LabelsOrder, Padding } from './Label.h'

import { Icon } from 'atoms/Icon'
import { SlidingTitle } from 'atoms/SlidingTitle'
import { TextAligning, TextBox, TextBoxTypes } from 'atoms/TextBox'
import { Borders, Corners, Fonts } from './Label.h'
import { IsLiveSC, LabelStyled } from './Label.styled'

export interface ILabelProps {
  'ref'?: Ref<HTMLDivElement>
  'className'?: string
  'title'?: ITextBoxProps['title']
  'fluid'?: boolean
  'padding'?: Padding
  'corners'?: Corners
  'borders'?: Borders
  'borderColor'?: BorderColors
  'font'?: Fonts
  'background'?: Backgrounds
  'color'?: COLOR
  'withDot'?: boolean
  'icon'?: IconNames | null
  'iconSize'?: IconSizes | IconQualitySizes | null
  'iconHeight'?: IconSizes
  'order'?: LabelsOrder
  'data-testid'?: string
  'sliding'?: boolean
}

export function Label({
  ref,
  className,
  title = '',
  fluid = false,
  padding,
  corners = Corners.CORNERS_10,
  borders = Borders.BORDER_0,
  borderColor,
  font = Fonts.Caption5,
  background,
  color,
  withDot,
  icon,
  iconSize,
  iconHeight,
  order,
  'data-testid': dataTestId,
  sliding,
}: ILabelProps): JSX.Element {
  return (
    <LabelStyled
      ref={ref}
      className={className}
      fluid={fluid}
      padding={padding}
      corners={corners}
      borders={borders}
      borderColor={borderColor}
      background={background}
      color={color}
      order={order}
      data-testid={dataTestId}
      sliding={sliding}
    >
      {withDot && <IsLiveSC />}
      {title && sliding && (
        <SlidingTitle title={title} font={TextBoxTypes[font]} />
      )}
      {title && !sliding && (
        <TextBox
          font={TextBoxTypes[font]}
          title={title}
          alignment={TextAligning.Center}
          maxLines={1}
        />
      )}
      {icon && <Icon name={icon} size={iconSize} height={iconHeight} />}
    </LabelStyled>
  )
}
